<template>
	<div>
		<app-app-header
			:title="t('label.finisherpoints')"
			v-model="indexStore.isHeaderVisible"
			:color="$config.public.colors.primary"
			:item-link="$auth.user ? {text: `${n($auth.user.finisherpoints)} ${t('abbreviation.points')}`, to: $web('my.finisherpoints.index')} : undefined"/>

		<app-content>
			<page-content background xs-full sm-full>
				<container xs-full sm-full>
					<card class="border-t-2 border-primary" xs-tile sm-tile>
						<card-image src="views/finisherpoints/cover-1.png" :size="{width: '100vw', ratio: 5/1}" class="border-b border-primary"/>

						<header-toolbar sticky-mobile>
							<tabs class="h-full" grow>
								<client-only>
									<tab v-for="(tabChildRoute, tabKey) in tabRoutes" replace :exact="tabChildRoute.exact" :value="tabKey" :key="tabKey"
										 :to="tabChildRoute.to"
										 :text="tabChildRoute.text"/>
								</client-only>
							</tabs>
						</header-toolbar>
					</card>

					<div id="content">
						<row reverse="lg">
							<column v-if="$device.isDesktop || $route.name.startsWith('my-finisherpoints_')" cols="12" lg="4">
								<sticky-content breakpoint="lg">
									<card xs-tile sm-tile>
										<card-text>
											<div class="flex items-center border-b pb-16 mb-16 h-64">
												<client-only>
													<template v-if="$auth.userLoaded">
														<template v-if="$auth.user">
															<avatar :model="$auth.user" :size="48" class="mr-24" round/>
															<div class="flex flex-column">
																<p class="text-3xl mb-2 font-bold font-heading text-heading-color leading-tight">{{ n($auth.user.finisherpoints) }}</p>
																<p class="text-uppercase mb-0 text-xs text-text-color leading-tight">{{ t('label.finisherpoints') }}</p>
															</div>
														</template>
														<wrapper v-else stretch>
															<btn :to="{path: $web('auth.login'), query: {redirect: $route.fullPath}}" color="primary" text>{{ t('action.login') }}</btn>
															<btn :to="{path: $web('auth.register'), query: {redirect: $route.fullPath}}" color="primary">{{
																	t('action.create_account')
																}}
															</btn>
														</wrapper>
													</template>
												</client-only>
											</div>
											<p class="mb-0 leading-spaced">{{ t('view.finisherpoints.index.description') }}</p>
										</card-text>
										<card-buttons stretch>
											<btn @click="openRedeemCouponModal" color="success" outlined>{{ t('action.add_coupon') }}</btn>
											<btn :to="$web('my.finisherpoints.store')">
												<span>Store</span>
											</btn>
										</card-buttons>
									</card>
								</sticky-content>
							</column>
							<column cols="12" lg="8" class="lg:m--8">
								<div class="h-full lg:h-auto lg:overflow-x-hidden lg:p-8">
									<NuxtPage/>
								</div>
							</column>
						</row>

					</div>
				</container>
			</page-content>

		</app-content>

		<lazy-ajax-form-modal v-if="$auth.user" v-model="showRedeemCouponModal"
							  :form-options="{action: $api('users.finisherpoints.store', $auth.user._key), method: 'POST', data: redeemCouponData}"
							  :modal-options="{title: t('action.add_coupon')}" :submit-text="t('action.add_coupon')" @success="handleRedeemedCoupon">

			<form-input large name="code" v-model="redeemCouponData.code" :label="t('label.coupon_code')" :rules="{required: true}"/>

		</lazy-ajax-form-modal>
	</div>
</template>

<script setup lang="ts">
import {useIndexStore} from "../../store";

const {$auth, $confirm, $web} = useNuxtApp();
const {t, n} = useI18n();
const route = useRoute();
const router = useRouter();
const indexStore = useIndexStore();

const redeemCouponData = ref({});
const showRedeemCouponModal = ref(false);

const tabRoutes = [
	{text: t('label.info'), to: $web('my.finisherpoints.index'), exact: true},
	{text: 'Store', to: $web('my.finisherpoints.store')},
	{text: t('label.achievements'), to: $web('my.finisherpoints.achievements')},
	$auth.loggedIn ? {text: t('label.credits'), to: $web('my.finisherpoints.transactions')} : null,
	$auth.loggedIn ? {text: t('label.orders'), to: $web('my.finisherpoints.orders')} : null,
].filter(item => !!item);

function openRedeemCouponModal() {
	if (!$auth.loggedIn) {
		$confirm({
			title: t('action.follow'),
			text: t('confirm.login_for_action.message'),
			type: 'info',
		}).then(({confirmed}) => {
			if (confirmed) {
				router.push({path: $web('auth.login'), query: {redirect: route.fullPath}})
			}
		});
		return;
	}

	redeemCouponData.value = {}
	nextTick(function () {
		showRedeemCouponModal.value = true;
	});
}

function handleRedeemedCoupon() {
	$auth.fetchUser()
}
</script>

